import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { NavBar } from "./navbar";
import { Footer } from "./footer";
import { Landing } from "../screens/landing";
import { Product } from "../screens/products/product";
import { Designs } from "../screens/design-templates/designs";
import { Design } from "../screens/design-templates/design";
import { Organizations } from "../screens/organizations/organizations";
import { Organization } from "../screens/organizations/organization";
import { CreateOrganization } from "../screens/organizations/create-organization";
import { Users } from "../screens/users/users";
import { Campaign } from "../screens/campaigns/campaign";
import { CreateUser } from "../screens/users/create-user";
import { Fonts } from "../screens/fonts/fonts";
import { ProductCatalog } from "../screens/product-catalog/catalog";
import { CreateProduct } from "../screens/product-catalog/edit-product";
import { Login } from "../screens/account/login";
import { Admin } from "../screens/admin/admin";
import { MemberPage } from "../screens/member/member";
import { DesignProductTemplates } from "../screens/design-product-templates/templates";
import { License } from "../screens/license/license";
import PrivateRoute from "../hooks/ProtectedRoute";
import { AuthProvider } from "../hooks/UseAuth";

export const Nav = () => {
  return (
    <Router>
      <AuthProvider>
        <div>
          <NavBar />
          <Switch>
            <PrivateRoute exact path="/" component={Landing} />
            <PrivateRoute exact path="/users" component={Users} />
            <PrivateRoute exact path="/create-user" component={CreateUser} />
            <Route exact path="/login" component={Login} />
            <PrivateRoute
              exact
              path="/organizations"
              component={Organizations}
            />
            <PrivateRoute
              exact
              path="/organization/:id"
              component={Organization}
            />
            <PrivateRoute exact path="/members/:id" component={MemberPage} />
            <PrivateRoute
              exact
              path="/create-organization"
              component={CreateOrganization}
            />
            <PrivateRoute exact path="/campaign" component={Campaign} />
            <PrivateRoute exact path="/campaign/:id" component={Campaign} />
            <PrivateRoute exact path="/products/:id" component={Product} />
            <PrivateRoute exact path="/license/:id" component={License} />
            <PrivateRoute exact path="/designs" component={Designs} />
            <PrivateRoute exact path="/design" component={Design} />
            <PrivateRoute exact path="/fonts" component={Fonts} />
            <PrivateRoute
              exact
              path="/product-catalog"
              component={ProductCatalog}
            />
            <PrivateRoute
              exact
              path="/product-catalog/create"
              component={CreateProduct}
            />
            <PrivateRoute
              exact
              path="/product-catalog/:id"
              component={CreateProduct}
            />
            <PrivateRoute exact path="/admin" component={Admin} />
            <PrivateRoute
              exact
              path="/product-templates"
              component={DesignProductTemplates}
            />
          </Switch>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
};
